import { render, staticRenderFns } from "./DeleteTypeDomaine.vue?vue&type=template&id=900e4d0e&"
import script from "./DeleteTypeDomaine.vue?vue&type=script&lang=js&"
export * from "./DeleteTypeDomaine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports